import SockJS from  'sockjs-client';
import  Stomp from 'stompjs';
import { getStorage } from '@/utils/storage'

export default {
  data(){
    return {
      headImg: '',
      nickName: '',
      userId: -1,
      stompClient:'',
      timer:'',
      chatList: [],
      liveStatus: 1,
      barrageType: { // 弹幕类型 1 用户弹幕  2 用户加入直播间  3  用户送礼物给主播
        default: 1,
        join: 2,
        attention: 3,
        gift: 4
      }
    }
  },
  mounted() {
    this.getUserInfoFromStorage()
  },
  methods:{
    getUserInfoFromStorage() {
      let userInfo = getStorage('live-userInfo') && JSON.parse(getStorage('live-userInfo'))
      if (userInfo) {
        this.headImg = userInfo.avatar || ''
        this.userId = userInfo.userId || ''
        this.nickName = getStorage('live-wx-nickname') || userInfo.nickname || ''
      }
    },
    initWebSocket() {
      this.getUserInfoFromStorage()
      this.connection();
      let that= this;
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      this.timer = setInterval(() => {
        try {
          that.stompClient.send("test");
        } catch (err) {
          console.log("断线重连: " + err);
          that.connection();
        }
      }, 5000);
    },
    connection() {
      let liveId = this.$route.query.id
      // 建立连接对象
      let socket = new SockJS(window.$liveApi.base_url + '/ws');
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket);

      const { account_id } = this.$route.query

      // 定义客户端的认证信息,按需求配置
      let headers = {
        userId: this.userId,
        liveId: liveId,
        headImg: this.headImg || 'https://ossimg.xinli001.com/20200605/6a1e7190708bad5fc11e918734bdd93e.png',
        source: 1,
        nickname: this.nickName,
        accountId: +account_id ? account_id : ''
      }

      // 向服务器发起websocket连接
      this.stompClient.connect(headers,() => {
        this.stompClient.subscribe(`/topic/${liveId}`, (msg) => { // 订阅服务端提供的某个topic
          this.handleMsg(msg)
        },headers);

        window.monitor && window.monitor.stat({
          logType: 'info',
          level: 'info',
          title: '直播-交互行为',
          remark: '连接socket',
          userId: this.userId,
          message: JSON.stringify({
            直播间id: liveId,
            ...headers
          })
        })
      }, (err) => {
        // 连接发生错误时的处理函数
        console.log('失败')
        console.log(err);
      });
    },    //连接 后台
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
    },  // 断开连接
    handleMsg(msg) {
      // console.log('收到广播')
      // console.log(JSON.parse(msg.body))
      let msgObj = JSON.parse(msg.body)
      switch (msgObj.pushType) {
        case 1: // 弹幕
          this.newMsg = {
            barrageType: this.barrageType.default,
            ...msgObj.userChatVo
          }
          break;
        case 2: // 公告
          break;
        case 3: // 仅主播可见公告
          break;
        case 4: // 点赞
          this.liveData.likeSum = msgObj.sum
          break;
        case 5: // 观看数量及最新三个用户头像
          msgObj.avatarList.forEach(item => {
            this.avatarList.push(item)
          })
          this.liveData.viewSum = msgObj.sum
          /*新用户显示在弹幕中 nickname为null时是游客，暂不显示*/
          if (msgObj.nickname) {
            this.newMsg = {
              barrageType: this.barrageType.join,
              nickname: msgObj.nickname || ''
            }
          }
          break;
        case 6: // 直播状态
          this.liveStatus = msgObj.liveStatus
          if (this.liveStatus === 2) {
            // this.aliplayer && this.aliplayer.dispose()
            this.txplayer && this.txplayer.dispose()
            this.disconnect();
          }
          break;
        case 7: // 连麦状态显示
          if (msgObj.connectStatus) {
            /*防止连接后再进行授权错过获取userId的时机，重新检测一遍是否有userInfo，更新userInfo和userId信息*/
            let userInfo = getStorage('live-userInfo') && JSON.parse(getStorage('live-userInfo'))
            if (userInfo) {
              this.userId = userInfo.userId || (userInfo.data && userInfo.data.id)
            }
            if (+this.userId === +msgObj.userChatVo.userId) {
              this.connectStatus = 2 // 被邀请连麦
            } else {
              this.connectStatus = 1 // 连麦中
            }
          } else {
            this.connectStatus = 0 // 无连麦
          }
          break;
        case 9: // 打赏处理
          if (msgObj.rewardType === 0) { // msgObj.rewardType===0时打赏成功
            /*加入弹幕*/
            this.newMsg = {
              barrageType: this.barrageType.gift,
              nickname: msgObj.userChatVo.nickname || '',
              giftName: msgObj.userChatVo.giftName || '',
              giftNum: msgObj.userChatVo.giftNum || '1'
            }
            /*加入礼物特效*/
            this.newGift = {
              avatar: msgObj.userChatVo.avatar,
              giftId: msgObj.userChatVo.giftId,
              nickname: msgObj.userChatVo.nickname || '',
              giftName: msgObj.userChatVo.giftName || '',
              giftNum: msgObj.userChatVo.giftNum || '1',
              giftImg: msgObj.userChatVo.giftImg
            }
          }
          break;
        case 12:
          this.updateAdvert && this.updateAdvert(msgObj)
          break;
        case 11:
          this.newMsg = {
            barrageType: this.barrageType.attention,
            nickname: msgObj.nickname || ''
          }
          break;
        case 14:
          this.updateAdvertList && this.updateAdvertList(msgObj.advertList)
          break;
      }
    },
    /**
     * 发送弹幕
     * @param {
      * 参数名 | 类型/范围 | 必选 | 说明
        ---|---|---|---
        userId | string | 是 | 用户id
        nickname | string | 是 | 用户昵称
        content | int | 是 | 评论/弹幕内容
        channelId | int | 是 | 频道id
        liveId | int | 是 | 直播间id
        avatar | int | 是 | 用户头像
        assistant | int | 是 | 0-普通用户 1-助手
      } userChatVo
     */
    sendMsg(userChatVo) {
      this.stompClient.send(`/chat/sendMessage`, {}, JSON.stringify({
        ...userChatVo,
        nickname: this.nickName
      }))
    }
  },
  beforeDestroy: function () {
    // 页面离开时断开连接,清除定时器
    this.disconnect();
    clearInterval(this.timer);
  }
}
